import {
  getFromSessionStorage,
  removeFromSessionStorage,
} from "@/utils/sessionStorageUtils";
import { SessionStorageKey } from "@/utils/storageKeys";

export const focusItemCard = () => {
  const idToFocus = getFromSessionStorage(
    SessionStorageKey.LAST_FOCUSED_ITEM_ID,
    ""
  );

  if (idToFocus) {
    removeFromSessionStorage(SessionStorageKey.LAST_FOCUSED_ITEM_ID);

    const element = document.getElementById(`item-card-${idToFocus}`);
    if (element) {
      element.focus();
    }
  }
};
